import {
  Button,
  Checkbox,
  Form,
  Grid,
  Input,
  Select,
  useForm,
} from "@pankod/refine-antd";
import { BaseKey, useCustom, useUpdate } from "@pankod/refine-core";
import { BaseOptionType, DefaultOptionType } from "antd/es/select";
import { RATE_TYPE_API, UPDATE_PAY_RATE_API } from "api/baseApi";
import { EAction, EStatusNotification, MSG_NOTIFICATION } from "constants/constant";
import { ICheckboxChangeActive } from "interfaces";
import { IService } from "interfaces/service";
import { IStandard } from "interfaces/standard";
import { useEffect, useState } from "react";
import { openNotification} from "utils";
import { StandardPayRatesProps } from "./interface";

const { Option } = Select;
export const StandardPayRatesUpdate = (props: StandardPayRatesProps) => {
  const breakpoint = Grid.useBreakpoint();
  const isMobile = !breakpoint.md;
  const { setIsModalVisible, payRate, isModalVisible, page, handleChange } =
    props;
  const [valuePayRate, setValuePayRate] = useState("");
  const { form, formProps } = useForm<IStandard>({
    action: EAction.EDIT,
  });

  const { data: servicesData } = useCustom({
    url: RATE_TYPE_API.getAll,
    method: "get",
    config: {
      query: {
        page: "",
        limit: "",
        search: "",
      },
    },
  });

  const { setFields } = form;

  const { mutate, data: updateData, isLoading } = useUpdate();

  const onFinish = (event: IStandard) => {
    mutate(
      {
        resource: UPDATE_PAY_RATE_API,
        id: payRate?.id as BaseKey,
        values: {
          rateTypeId: event.rateTypeId,
          payRate: event.payRate,
          interpreterId: payRate?.interpreterId,
          languageType: event.languageType,
          isActive: event.isActive,
        },
      },
      {
        onError: (error) => {
          
          openNotification(MSG_NOTIFICATION.ERROR, error.message, EStatusNotification.ERROR, 2);;
        },
      }
    );
  };

  useEffect(() => {
    form.resetFields();
    setFields([
      {
        name: "rateTypeId",
        value: payRate?.rateTypeId,
      },
      {
        name: "payRate",
        value: payRate?.payRate,
      },
      {
        name: "interpreterId",
        value: payRate?.interpreterId,
      },
      {
        name: "isActive",
        value: payRate?.isActive,
      },
      {
        name: "languageType",
        value: payRate?.languageType,
      },
    ]);
  }, [payRate, form, isModalVisible]);

  useEffect(() => {
    if (updateData?.data.status == 200) {
      form.resetFields();
        openNotification(MSG_NOTIFICATION.SUCCESSFUL, updateData?.data?.message, EStatusNotification.SUCCESS);
      setIsModalVisible(false);
    }
  }, [updateData, form, setIsModalVisible]);

  const onCheck = (event: ICheckboxChangeActive) => {
    if (event.target.checked) {
      form.setFieldsValue({ isActive: true });
    } else {
      form.setFieldsValue({ isActive: false });
    }
  };

  return (
    <Form
      {...formProps}
      layout="vertical"
      onFinish={(event) => onFinish(event as IStandard)}
    >
      <Form.Item
        label="Rate Type"
        name="rateTypeId"
        rules={[
          {
            required: true,
            message: "Please enter rate type",
          },
        ]}
        initialValue={payRate?.rateTypeId}
      >
        <Select
          style={{ width: "100%" }}
          optionFilterProp="children"
          filterOption={(
            input,
            option: BaseOptionType | DefaultOptionType | undefined
          ) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
        >
          {servicesData?.data?.results.map((item: IService, index: number) => (
            <Select.Option key={index} value={item.id}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Rate (per minute)"
        name="payRate"
        rules={[
          {
            required: true,
            pattern: /^-?\d*(\.\d*)?$/,
            message: "Please enter a valid number",
          },
        ]}
        normalize={(value, prevVal, prevVals) => value.trim()}
        initialValue={payRate?.payRate}
      >
        {/* <NumericInput
          value={valuePayRate}
          onChange={(e) => setValuePayRate(e)}
        /> */}
        <Input maxLength={50} />
      </Form.Item>
      <Form.Item
        label="Language"
        name="languageType"
        rules={[
          {
            required: true,
            message: "Please enter language",
          },
        ]}
        initialValue={payRate?.languageType}
      >
        <Select placeholder="language">
          <Option value={0}>All other languages</Option>
          <Option value={1}>American Sign Language</Option>
          <Option value={2}>Spanish</Option>
        </Select>
      </Form.Item>

      <Form.Item
        name="isActive"
        valuePropName="checked"
        initialValue={payRate?.isActive}
      >
        <Checkbox
          onChange={(event) => {
            onCheck(event);
          }}
        >
          Is Active
        </Checkbox>
      </Form.Item>

      <div className={!isMobile ? "submit" : ""}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Save
        </Button>
      </div>
    </Form>
  );
};
